var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePaperplane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96036 11C7.32846 11 7.58329 10.7027 7.7579 10.2496L10.8726 2.09958C10.9528 1.89193 11 1.70788 11 1.54743C11 1.21236 10.7876 1 10.4479 1C10.2921 1 10.1034 1.04247 9.89571 1.1227L1.7126 4.25625C1.30675 4.41199 1 4.66682 1 5.03492C1 5.48325 1.33506 5.65314 1.79755 5.79471L4.2421 6.54035C4.57244 6.64417 4.76593 6.63945 4.99717 6.42237L10.2544 1.55215C10.3204 1.4908 10.4007 1.50024 10.4526 1.54743C10.5045 1.59462 10.5045 1.67957 10.4479 1.74092L5.58707 7.00755C5.38886 7.22935 5.36999 7.437 5.46909 7.76734L6.19585 10.1647C6.33742 10.6461 6.50731 11 6.96036 11Z",
    fill: "#008FDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePaperplane);
export default __webpack_public_path__ + "static/media/blue-paperplane.4e72c0a9cf5e9e460e1bd783664f2d9f.svg";
export { ForwardRef as ReactComponent };